import { render, staticRenderFns } from "./SubSetting1.vue?vue&type=template&id=535364cb&scoped=true"
import script from "./SubSetting1.vue?vue&type=script&lang=js"
export * from "./SubSetting1.vue?vue&type=script&lang=js"
import style0 from "./SubSetting1.vue?vue&type=style&index=0&id=535364cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535364cb",
  null
  
)

export default component.exports